import { Target, Crown, ShieldAlert, Swords, Flame, Medal, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES, CONTACT, ELITE_DETAILS } from "../data/content";

const ICONS = { Target, Crown, ShieldAlert, Swords, Flame, Medal };

export default function Elite() {
  return (
    <main className="pt-20 sm:pt-24">
      <section className="relative py-40 overflow-hidden noise-overlay" data-testid="elite-hero">
        <img src={IMAGES.elite2} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <img src={IMAGES.heroFire} alt="" className="absolute inset-0 w-full h-full object-cover mix-blend-screen opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-[#050505]/40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
          <Reveal>
            <Overline>The Elite Batch</Overline>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter max-w-3xl" data-testid="elite-headline">
              Only for the Best. <span className="text-[#D4AF37]">Invite-Only.</span>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-24" data-testid="elite-details">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {ELITE_DETAILS.map((d, i) => {
              const Icon = ICONS[d.icon];
              return (
                <Reveal key={d.title} delay={i * 0.06}>
                  <div className="bg-[#050505] p-10 lg:p-12 h-full transition-colors duration-300 hover:bg-[#0F0F0F]" data-testid={`elite-detail-${i}`}>
                    <Icon size={26} className="text-[#D4AF37] mb-6" />
                    <h3 className="font-heading text-xl font-bold text-white">{d.title}</h3>
                    <p className="text-white/50 text-sm leading-relaxed mt-3">{d.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal className="mt-16">
            <a
              href={CONTACT.whatsappElite}
              target="_blank"
              rel="noreferrer"
              data-testid="elite-cta-join"
              className="inline-flex items-center gap-3 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-sm px-10 py-4 rounded-sm transition-all duration-200 hover:bg-[#F3D059] hover:-translate-y-1 gold-glow"
            >
              Join the Elite Batch <ArrowRight size={16} />
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
